import { CardContent } from "@libs/zapi-ui/shadcn";
import { TipTapEditor } from "@/zapi-frontend/widgets/TipTapEditor";

type TProps = {
  isEditable: boolean;
  className?: string;
  projectId: string;
};

export function EditorTab(props: TProps) {
  const { isEditable, projectId } = props;

  return (
    <CardContent className={"p-0 flex-1 flex flex-col h-full " + props.className}>
      <TipTapEditor editable={isEditable} autoSave projectId={projectId} />
    </CardContent>
  );
}
